export const storage = {
	zeroProducts: {
		noProproductIsSelected: "Ningún producto seleccionado",
	},
	removeProduct: {
		noProproductIsSelected: "Ningún producto seleccionado",
	},
	layout: {
		goBack: "Volver",
	},
	indicators: {
		cost: {
			title: "Valor total en inventario",
		},
		turnover: {
			high: "Mayor rotación",
			low: "Menor rotación",
		},
		zeroed: {
			title: "Productos agotados",
			seeMore: "Ver Más",
		},
		intervalNotice: "Valores referentes a los últimos 90 días",
		updatedAt: "Actualizado en {{date}}",
		noZeroedProductsFound: "Ningún producto agotado encontrado",
		arialLabel: {
			dashboardTitle: "Panel de métricas de inventario",
			indicatorsList: "Indicadores de inventario",
			dataVisualization: "Visualización de datos de {{title}}",
			seeMoreButton: "Ver más productos con cantidad cero",
			zeroedProductsPreview: "Vista previa de productos con cantidad cero",
			storageUnit: "Unidad de inventario {{name}}",
			productWithZeroQuantity: "{{name}}, producto con cantidad cero",
		},
	},
	modalXML: {
		title: "Importar XML",
		warningMessage: {
			line1:
				"Seleccione el inventario de destino, descargue la hoja de cálculo ejemplo, llene e importe nuevamente.",
			line2:
				"¡Atención! El valor de los productos se informa en centavos. Ej: 123 equivale a {{currencySymbol}} 1,23",
		},
		form: {
			label: {
				storage: "Inventario",
				xml: "XML",
			},
			placeholder: {
				xml: "Elija un archivo .xml para importar",
			},
			validation: {
				missingField: "Campo obligatorio",
			},
			submit: "Importar Factura",
		},
	},
	modalManualChange: {
		title: {
			add: 'Agregar producto "{{prodName}}"',
			subtract: 'Eliminar producto "{{prodName}}"',
		},
		okText: {
			add: "Agregar producto",
			subtract: "Eliminar producto",
		},
		cancel: "Cancelar",
		message: {
			add: "Ingrese la cantidad de producto que quiere agregar y el precio de costo",
			subtract:
				"Ingrese la cantidad que desea eliminar y una observación si es necesario",
		},
		form: {
			hasProductionRuleWarning:
				"Este producto tiene ficha técnica y sus elementos serán reducidos del inventario solo cuando estén agotados.",
			label: {
				quantity: "Cantidad",
				costPrice: "Precio de costo",
				obs: "Observación",
			},
			validation: {
				invalidQuantity: "Cantidad inválida",
				missingProductInfo: "Falta información de producto",
				missingActionInfo: "Falta información de acción",
			},
		},
	},
	header: {
		searchPlaceHolder: "Buscar por producto",
		importXML: "Importar vía XML",
		transferProducts: "Transferir productos",
		addProducts: "Agregar productos",
		addProductsManually: "Agregar productos manualmente",
		actionsToolbar: "Acciones del inventario",
		importViaXlsx: "Importar vía Excel",
	},
	table: {
		columns: {
			name: "producto",
			category: "categoría",
			quantity: "cantidad",
			action: "acción",
			lastCost: "último precio",
			avgCost: "precio promedio",
			totalCost: "costo total",
		},
		actions: {
			zeroStorage: "Agotar inventario",
			removeProducts: "Eliminar productos",
			label: "Acciones en lote",
			message: "Seleccione el check box para acciones en lote",
		},
		confirmationModal: {
			warnignHiddenProductsInSearch:
				"Atención, algunos productos pueden estar ocultos por causa de la búsqueda, limpie la búsqueda para continuar",
			deleteSingle: {
				title: "Eliminar producto",
				message:
					"Al confirmar la acción usted elimina permanentemente estos elementos del inventario. ¿Desea continuar?",
				confirmMessage: "Sí, deseo eliminar",
			},
			deleteMultiple: {
				title: "Eliminar producto",
				message:
					"Al confirmar la acción usted elimina permanentemente estos elementos del inventario. ¿Desea continuar?",
				confirmMessage: "Sí, deseo eliminar",
			},
			zero: {
				title: "Zerar cantidad de productos",
				messagePrefix: "Você está prestes a zerar a quantidade",
				allMessage: "de todos los productos seleccionados ({{total}} productos).",
				selectedMessage: "de {{selectedTotal}} productos seleccionados.",
				messageSuffix: "¿Está seguro de que desea continuar?",
				confirmMessage: "Zerar productos",
			},
		},
		filters: {
			categoryPlaceholder: "Filtrar por categoría",
			productPlaceholder: "Buscar por nombre del producto",
			suggestions: "Sugestiones",
			other: "Otros",
		},
		selectedProductsCount: "Todos los productos seleccionados: {{total}} productos",
	},
	inputViaXlsx: {
		header: {
			title: "Importar productos vía Excel",
		},
		layout: {
			importProductsTable: "Importe su tabla de productos",
			tutorial: "Agregue 1 o más productos de una vez importando una hoja de cálculo.",
		},
		form: {
			dropzoneTitle: "Arrastre y suelte el archivo aquí",
			dropzoneSubtitle: "o haga clic para seleccionar el archivo",
			fileDetails: "Tipo de archivo: {{fileType}} hasta {{fileSize}}",
			downloadSample: "Descargar tabla ejemplo",
			totalProducts: "Total de productos",
			successfullyImported: "Productos importados",
			productsWithErrors: "Productos con error",
			downloadInvalidSheet: "Descargar tabla con errores",
			alert: {
				title: "Productos con error",
				message:
					"Identificamos algunos productos con información incorrecta. Descargue la hoja de cálculo con los errores, corrija los datos y, enseguida, realice la importación nuevamente.",
			},
			errorImporting: "No fue posible importar la tabla",
			selectFile: "Seleccione un archivo",
			selectAnotherFile: "Seleccione otro archivo",
			tooltip: {
				totalProducts: "Su tabla tenía {{totalProducts}} productos",
				successfullyImported:
					"{{totalProducts}} productos ya fueron importados con éxito a su inventario",
				productsWithErrors: "Descargue la tabla con errores y haga el upload nuevamente",
			},
		},
		sheet: {
			columns: {
				productName: "Producto",
				quantity: "Cantidad",
				unit: "Unidad de medida",
				costPrice: "Precio de costo",
				costType: "Tipo de costo",
			},
			costType: {
				byUnit: "Costo unitario",
				byTotal: "Costo total",
			},
			sampleFileName: "ejemplo_entrada_productos.xlsx",
			errorFileName: "entrada_productos_con_error.xlsx",
		},
	},
};
